import '.x{position:fixed;}.ssr-plugin'
import '.ca{top:0px;}.ssr-plugin'
import '.bk{left:0px;}.ssr-plugin'
import '.bl{right:0px;}.ssr-plugin'
import '.ft{bottom:0px;}.ssr-plugin'
import '.hk{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.hl{z-index:998;}.ssr-plugin'
import '.hm{transition:opacity 0.3s ease;}.ssr-plugin'
import '.p{height:100vh;}.ssr-plugin'
import '.a0{width:100%;}.ssr-plugin'
import '.af{background-color:var(--palette-white);}.ssr-plugin'
import '.hn{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.ho{z-index:999;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.a1{justify-content:space-between;}.ssr-plugin'
import '.bd{padding:1.5rem;}.ssr-plugin'
import '.hp{border-bottom:var(--border-default);}.ssr-plugin'
import '.bn{flex-shrink:0;}.ssr-plugin'
import '.bj{flex:1;}.ssr-plugin'
import '.al{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="x ca bk bl ft hk hl hm"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="x ca p a0 af hn ho a b"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="a c a1 bd hp bn"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="bj al bd"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
